<template>
  <span>
    <b-btn
      size="sm"
      @click="deleteShareMovement"
      variant="outline-secondary"
      v-b-tooltip.hover
      title="Delete share movement"
    >
      <i class="fa fa-trash text-muted"></i>
    </b-btn>
  </span>
</template>

<script>
import { get } from "dot-prop";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

export default {
  name: "share-movement-update-buttons",
  props: {
    shareMovementId: {
      type: String,
      description: "Share movement ID",
      required: true,
    },
    accountId: {
      type: String,
      description: "Account ID",
      required: true,
    },
    companyId: {
      type: String,
      description: "Company ID",
      required: true,
    },
  },
  data() {
    return {
      deleting: false,
    };
  },
  methods: {
    deleteShareMovement() {
      swal
        .fire({
          title: "Are you sure?",
          text: "This share movement will be deleted",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "gray",
          confirmButtonText: "Yes, delete!",
          reverseButtons: true,
          showLoaderOnConfirm: true,
          preConfirm: (login) => {
            return this.axios
              .delete(
                `/v1/accounts/${this.accountId}/companies/${this.companyId}/share-movements/${this.shareMovementId}`
              )
              .then((response) => {
                return response;
              })
              .catch((error) => {
                swal.showValidationMessage(
                  `Request failed: ${error.response.data.message}`
                );
              });
          },
          allowOutsideClick: () => !swal.isLoading(),
        })
        .then((result) => {
          if (result.value) {
            swal.fire("Done!", "The share movement was deleted", "success");
            // emit event so we can reload data in parent
            this.$emit("share-movement-deleted", this.shareMovementId);
          }
        });
    },
  },
};
</script>
